<template>
	<PaymentProgressStatusBox :status-code="status.code"
							  :status-tooltip="status.name"
	/>
</template>

<script>
import PaymentProgressStatusBox from "@/components/templates/common/payments/PaymentProgressStatusBox";
import {paymentProgress} from "@/common/utils/paymentProgress";

export default {
	components: { PaymentProgressStatusBox },
	computed: {
		status() {
			return paymentProgress.getStatusForFee(this.params.data.paymentStatus);
		}
	}
};
</script>